import { PlaylistComponent } from './components/playlist/playlist.component';
import { DirectoryComponent } from './components/directory/directory.component';
import { LoginComponent } from './components/login/login.component';
import { InstallComponent } from './components/install/install.component';

export const routes = [
  {
    path: ':company/playlist/:id',
    name: 'playlist',
    data: {
      title: 'Playlist',
      icon: 'ondemand_video'
    },
    component: PlaylistComponent
  },
  {
    path: ':company/playlist',
    name: 'playlist',
    data: {
      title: 'Playlist',
      icon: 'ondemand_video'
    },
    component: PlaylistComponent
  },
  {
    path: ':company/directory',
    name: 'directory',
    data: {
      title: 'Training Library',
      icon: 'video_library'
    },
    component: DirectoryComponent
  },
  {
    path: ':company/login',
    name: 'login',
    data: {
      title: 'Login',
      icon: 'video_library'
    },
    component: LoginComponent
  },
  {
    path: ':company',
    name: 'login',
    data: {
      title: 'Login',
      icon: 'video_library'
    },
    component: LoginComponent
  },
  {
    path: 'login',
    name: 'login',  
    data: {
      title: 'Login',
      icon: 'video_library'
    },
    component: LoginComponent
  },
  {
    path: '',
    name: 'login',  
    data: {
      title: 'Login',
      icon: 'video_library'
    },
    component: LoginComponent
  },
  {
    path: ':company/install',
    name: 'install',
    data: {
      title: 'Install',
      icon: 'system_update'
    },
    component: InstallComponent
  }
  // {
  //   path: 'about',
  //   loadComponent: () => import('./views/about/about.component').then(m => m.AboutComponent)
  // }
];